import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ParticipantsGrid } from './ParticipantsGrid';
import { ParticipantsList } from './ParticipantList';
import { ParticipantsView } from '../../constants';
import { actions as callActions, selectors as callSelectors, } from '../../../call';
import { getParticipantForActions, getParticipantsView } from '../../selectors';
import { ParticipantActions } from './ParticipantActions';
import { useIsCallFrameOpen } from '../../hooks';
const Participants = ({ selfParticipant, }) => {
    const dispatch = useDispatch();
    const currentView = useSelector(getParticipantsView);
    const isCallFrameOpen = useIsCallFrameOpen();
    const participantSelector = isCallFrameOpen
        ? callSelectors.getSortedParticipantsWhenCallFrameIsActive
        : callSelectors.getSortedParticipants;
    const participants = useSelector(participantSelector);
    const alphabeticallySortedParticipants = useSelector(callSelectors.getAlphabeticallySortedParticipants);
    const participantForActions = useSelector(getParticipantForActions);
    useEffect(() => {
        dispatch(callActions.updateVideoSubscriptions(participants));
    }, [participants]);
    return (<>
      <ParticipantsGrid participants={participants} selfParticipant={selfParticipant}/>
      {currentView === ParticipantsView.List ? (<ParticipantsList participants={alphabeticallySortedParticipants} selfParticipant={selfParticipant}/>) : null}
      {participantForActions ? (<ParticipantActions participant={participantForActions}/>) : null}
    </>);
};
export default Participants;
